import {Component,ElementRef,Input,OnInit,Output,ViewChild,EventEmitter,} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { MultiSelectorDetails } from 'src/app/model/multi-selector-details';
import { messages } from 'src/app/resources/messages';
import { CatalogService } from 'src/app/services/catalog.service';

@Component({
  selector: 'company-dropdown',
  templateUrl: './company-dropdown.component.html',
  styleUrls: ['./company-dropdown.component.scss']
})
export class CompanyDropdownComponent implements OnInit {

  @Input() isOptional: boolean = true;
  @Input() displayLabel!: string;
  @Input() allowMultiSelect: boolean = true;
  @Input() selectorControlName!: AbstractControl<string>;
  @Input() submitted!: string;
  @Input() ariaText: string ='Company drop down';
  @Output() selectedValues = new EventEmitter<string[]>();
  @Input() defaultStatus: MultiSelectorDetails = { id: '', description: [] };
  @Input() companyPredefinedList:any = [];

  @ViewChild('companyListReference') companyRef: ElementRef | undefined;

  public msg = messages;
  public companyList: MultiSelectorDetails[] = [];
  public maxSelectionCount: number | undefined;
  public componentId!: string;
  public selectedValue: any;
  constructor(private catalogService: CatalogService) { }

  ngOnInit(): void {
    this.setId();
    this.getCompaniesData();
    this.setMaxlimit();
  }

  private getCompaniesData() {
    this.catalogService.getCompanies().subscribe(response => {
      if(this.companyPredefinedList?.length >= 1){
        this.companyList = response.data.filter(x => this.companyPredefinedList?.includes(x.companyId))
        .map(x => <MultiSelectorDetails><unknown>{
          id: x.companyId,
          description: [x.companyName]
        })
      }else{
        this.companyList = response.data.map(x => <MultiSelectorDetails><unknown>{
          id: x.companyId,
          description: [x.companyName]
        });
      }

      setTimeout(()=> { this.selectedValue = this.defaultStatus; }, 500);
    })
  }

  public setSelectedCompany($event: any) {
    let companySelectedList: string[] = $event.detail?.selectedItemArray.map(
      (x: MultiSelectorDetails) => x.id
    );
    this.selectedValues.emit(companySelectedList);
    if (this.maxSelectionCount === 1) {
      this.companyRef?.nativeElement.closeSelectionPanel();
    }
  }

  private setMaxlimit() {
    if (this.allowMultiSelect) {
      this.maxSelectionCount = undefined;
    } else {
      this.maxSelectionCount = 1;
    }
  }

  private setId() {
    if (!this.displayLabel) {
      this.componentId = 'Company';
    } else {
      this.componentId = this.displayLabel.replace(' ', '-');
    }
  }

  public reset() {
    if(!this.defaultStatus?.id || this.defaultStatus?.id !== this.selectedValue?.id){
      this.companyRef?.nativeElement.resetSelectMenu();
    }
    if(this.defaultStatus?.id){
      this.selectedValue = this.defaultStatus;
    }
  }

  public getAllCompany(): string[] {
    let allCompany = this.companyList.map(
      (x: MultiSelectorDetails) => x.id!);
    return allCompany;
  }

}
